// Re-export shim (MODU-M9 — FE service-layer unification).
//
// This file moved to `src/lib/api/auth-service.ts` so all API service
// modules live under one convention (`src/lib/api/<domain>-service.ts`,
// per nue2025_front/CLAUDE.md). Kept here so existing
// `@/lib/services/auth-service` / `../services/auth-service` imports keep
// resolving without touching every call site. New code should import from
// `@/lib/api/auth-service` directly.
export * from '../api/auth-service';
export { default } from '../api/auth-service';
